import React from "react";

import {Container} from "@pg-design/grid-module";
import {HomeIcon} from "@pg-design/icons-module";
import {rpAppLink} from "@pg-mono/rp-routes";

import {Breadcrumbs} from "../../app/components/breadcrumbs/Breadcrumbs";
import {BreadcrumbsItem} from "../../app/components/breadcrumbs/BreadcrumbsItem";

export enum CreditBreadcrumbType {
    OFFERS = 1,
    RATING = 2
}

interface ICreditBreadcrumb {
    name: string;
    url: string;
    position: string;
    isLinkingToCurrentLocation: boolean;
}

interface IProps {
    breadcrumbType?: CreditBreadcrumbType;
}

export const CreditBreadcrumbs = (props: IProps) => {
    const creditBreadcrumbs: ICreditBreadcrumb[] = [
        {
            name: "kredyty",
            url: rpAppLink.credits.base(),
            position: "2",
            isLinkingToCurrentLocation: !props.breadcrumbType
        }
    ];

    addBreadcrumbsFromType(creditBreadcrumbs, props.breadcrumbType);

    return (
        <Container>
            <Breadcrumbs homePageUrl={rpAppLink.base()} homePageIcon={<HomeIcon size="1.4" />}>
                {creditBreadcrumbs.map((item) => (
                    <BreadcrumbsItem
                        key={item.name}
                        name={item.name}
                        position={item.position}
                        url={item.url}
                        isLinkingToCurrentLocation={item.isLinkingToCurrentLocation}
                    />
                ))}
            </Breadcrumbs>
        </Container>
    );
};

const addBreadcrumbsFromType = (breadcrumbsArray: ICreditBreadcrumb[], type?: CreditBreadcrumbType) => {
    switch (type) {
        case CreditBreadcrumbType.OFFERS:
            breadcrumbsArray.push({
                name: "kalkulator kredytu",
                url: rpAppLink.credits.offers(),
                position: "3",
                isLinkingToCurrentLocation: true
            });
            break;
        case CreditBreadcrumbType.RATING:
            breadcrumbsArray.push({
                name: "kalkulator zdolności",
                url: rpAppLink.credits.rating(),
                position: "3",
                isLinkingToCurrentLocation: true
            });
            break;
        default:
            return;
    }
};
import React from "react";

import {Container} from "@pg-design/grid-module";
import {HomeIcon} from "@pg-design/icons-module";
import {rpAppLink} from "@pg-mono/rp-routes";

import {Breadcrumbs} from "../../app/components/breadcrumbs/Breadcrumbs";
import {BreadcrumbsItem} from "../../app/components/breadcrumbs/BreadcrumbsItem";

export enum CreditBreadcrumbType {
    OFFERS = 1,
    RATING = 2
}

interface ICreditBreadcrumb {
    name: string;
    url: string;
    position: string;
    isLinkingToCurrentLocation: boolean;
}

interface IProps {
    breadcrumbType?: CreditBreadcrumbType;
}

export const CreditBreadcrumbs = (props: IProps) => {
    const creditBreadcrumbs: ICreditBreadcrumb[] = [
        {
            name: "kredyty",
            url: rpAppLink.credits.base(),
            position: "2",
            isLinkingToCurrentLocation: !props.breadcrumbType
        }
    ];

    addBreadcrumbsFromType(creditBreadcrumbs, props.breadcrumbType);

    return (
        <Container>
            <Breadcrumbs homePageUrl={rpAppLink.base()} homePageIcon={<HomeIcon size="1.4" />}>
                {creditBreadcrumbs.map((item) => (
                    <BreadcrumbsItem
                        key={item.name}
                        name={item.name}
                        position={item.position}
                        url={item.url}
                        isLinkingToCurrentLocation={item.isLinkingToCurrentLocation}
                    />
                ))}
            </Breadcrumbs>
        </Container>
    );
};

const addBreadcrumbsFromType = (breadcrumbsArray: ICreditBreadcrumb[], type?: CreditBreadcrumbType) => {
    switch (type) {
        case CreditBreadcrumbType.OFFERS:
            breadcrumbsArray.push({
                name: "kalkulator kredytu",
                url: rpAppLink.credits.offers(),
                position: "3",
                isLinkingToCurrentLocation: true
            });
            break;
        case CreditBreadcrumbType.RATING:
            breadcrumbsArray.push({
                name: "kalkulator zdolności",
                url: rpAppLink.credits.rating(),
                position: "3",
                isLinkingToCurrentLocation: true
            });
            break;
        default:
            return;
    }
};
